<template>
  <div
    class="border-t border-r border-gray-800 dark:border-gray-100 fixed bottom-0 left-0 z-50
           px-3 py-2 flex items-center justify-center gap-2 rounded-tr-xl bg-white dark:bg-black"
  >
    <UiThemeToggle size="sm" />
    <UiLocaleSwitch size="sm" />
  </div>
</template>

<script setup lang="ts">
import UiThemeToggle from '@/components/ui/UiThemeToggle.vue';
import UiLocaleSwitch from '@/components/ui/UiLocaleSwitch.vue';
</script>
